import { ADDED, ALLCOMPLETED, CLEARCOMPLETED, COLORSELECTED, DELETED, LOADED, TOGGLEDFEATURE, UPDATE } from "./actionTypes";
import initialState from "./initialState";

const nextTodoId = (todos) => {
    const maxId = todos.reduce((maxId, todo) => Math.max(todo.id, maxId), -1);
    return maxId + 1;
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADED:
            return action.payload;

            case ADDED:
                return [
                    ...state,
                    {
                        id: nextTodoId(state),
                        ...action.payload,
                       
                    },
                ];
    


        case UPDATE:
            return state.map((book) => {
                if (book.id !== action.payload.id) {
                    return book;
                }

                return {
                    ...action.payload,
                };
            });

        case COLORSELECTED:
            const { todoId, color } = action.payload;
            return state.map((todo) => {
                if (todo.id !== todoId) {
                    return todo;
                }
                return {
                    ...todo,
                    color: color,
                };
            });

        case DELETED:
            return state.filter((todo) => todo.id !== action.payload);

        case ALLCOMPLETED:
            return state.map((todo) => {
                return {
                    ...todo,
                    completed: true,
                };
            });

        case CLEARCOMPLETED:
            return state.filter((todo) => !todo.completed);
        case TOGGLEDFEATURE:
            return state.filter((book) => action.payload !=="all" ? book.name!=="" : book.featured==true);

        default:
            return state;
    }
};

export default reducer;
